import { IElementWaypoint } from "@/hooks/use-placeholders";
import { IElement } from "@faro-lotv/ielement-types";
import { useMemo } from "react";

type UsePlaceholderHoverTooltipProps = {
  /** The currently hovered waypoint, if available */
  waypoint?: IElementWaypoint;

  /** Whether the move interaction is enabled */
  enableMoving?: boolean;

  /**
   * Function to compute on demand, whether a placeholder is allowed to be moved.
   * Should either return false, or a string with a reason why the placeholder cannot be moved.
   * If not provided, all placeholders are allowed to be moved.
   */
  isPlaceholderDisabledForMove?(el: IElement): string | false;
};

/**
 * @returns A tooltip message to display when hovering a waypoint.
 */
export function usePlaceholderHoverTooltip({
  waypoint,
  enableMoving,
  isPlaceholderDisabledForMove,
}: UsePlaceholderHoverTooltipProps): string | undefined {
  return useMemo(() => {
    if (enableMoving && waypoint) {
      const disabledForMove = isPlaceholderDisabledForMove?.(waypoint);
      return typeof disabledForMove === "string" ? disabledForMove : undefined;
    }
  }, [enableMoving, waypoint, isPlaceholderDisabledForMove]);
}
